// extracted by mini-css-extract-plugin
export default {"container":"header_container__2HJGa","wrapper":"header_wrapper__c+vlU","row":"header_row__o+XlQ","title":"header_title__8H6WT","subtitle":"header_subtitle__-LB18"};